import { store } from "@redux"

const registerLastOnlineTime = () => {
  const branchId =
    store.getState().userAccountInfo.branchId

  const json =
    localStorage.getItem("lastOnlineTimes")

  const lastOnlineTimes =
    JSON.parse(json || "{}")

  lastOnlineTimes[branchId] = String(Date.now())

  const newLastOnlineTimes =
    JSON.stringify(lastOnlineTimes)

  localStorage.setItem(
    "lastOnlineTimes",
    newLastOnlineTimes
  )
}

export default registerLastOnlineTime